package com.neurobs.js.dom

import com.neurobs.js.view.SoundView
import scalatags.JsDom.all._

class DOMSoundView (alertUrl: String, notificationUrl: String) extends SoundView {
	private val alertSound = audio(src := alertUrl).render
	private val notificationSound = audio(src := notificationUrl).render

	override def playAlert(): Unit = alertSound.play()
	override def playNotify(): Unit = notificationSound.play()
}
